<template></template>
<script setup>
import Chat from "./chat.js";
import { onMounted } from "vue";

onMounted(() => {
  setTimeout(() => {
    if (
      !!localStorage.getItem("token") &&
      !!localStorage.getItem("refreshToken") &&
      self == top
    ) {
      initCS();
      if (window.$ZConfig.getVal("TM_CHAT_SWITCH")) {
        Chat();
      }
    }
  }, 1000);
});
const initCS = async () => {
  if (location.pathname.toLocaleLowerCase().startsWith("/login")) {
    return;
  }
  const YSFService = await window
    .useBehavior({
      from: "/m/cx/behavior",
      name: "YSF",
    })
    .catch((err) => {
      console.log("err", err);
    });

  console.log("YSFService", YSFService);

  let env = "h5";
  if ($jump.env.flutter || $jump.env.hm) {
    env = "app";
  } else if ($jump.env.weixin) {
    env = "wx";
  }
  window.$CS = new YSFService({
    from: env,
  });
  window.$CS.show();
};
</script>
